import { render, staticRenderFns } from "./PsConfigurationConcepts.vue?vue&type=template&id=cd6d3afc&scoped=true&"
import script from "./PsConfigurationConcepts.vue?vue&type=script&lang=js&"
export * from "./PsConfigurationConcepts.vue?vue&type=script&lang=js&"
import style0 from "./PsConfigurationConcepts.vue?vue&type=style&index=0&id=cd6d3afc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6d3afc",
  null
  
)

export default component.exports